import slice from './reducer'
import emailsConfigurationSaga from './sagas'

export const {
  fetchRequest: fetchEmailConfigurationRequest,
  fetchSuccess: fetchEmailConfigurationSuccess,
  fetchError: fetchEmailConfigurationError,
  confirmRequested: confirmEmailConfigurationRequested,
  confirmSuccess: confirmEmailConfigurationSuccess,
  confirmError: confirmEmailConfigurationError,
  initFetchRequest: initFetchEmailConfigurationRequest,
  initFetchError: initFetchEmailConfigurationError,
  syncRequested: syncEmailConfigurationRequested,
  syncSuccess: syncEmailConfigurationSuccess,
  syncError: syncEmailConfigurationError,
  deleteRequested: deleteEmailConfigurationRequested,
  deleteSuccess: deleteEmailConfigurationSuccess,
  deleteError: deleteEmailConfigurationError,

  confirmSmtpRequested: confirmSmtpConfigurationRequested,
  confirmSmtpSuccess: ConfirmSmtpConfigurationSuccess,
  confirmSmtpError: confirmSmtpConfigurationError,
  syncSmtp: syncSmtpRequested,
} = slice.actions

export default slice.reducer
export { emailsConfigurationSaga }
